export * from './analytics-store';
export * from './application-store';
export * from './configurations-store';

import { pageCreator } from '$scripts/page-creator';
import { setSentry } from '$shared/helpers';
import { getLoggers } from '$shared/loggers';
import { Locale } from 'locales';
import { getAnalyticsState } from './analytics-store';
import {
  ApplicationState,
  getApplicationState,
  getApplicationStore,
} from './application-store';
import {
  getConfigurationsState,
  getConfigurationsStore,
} from './configurations-store';

export const initializeApplication = (
  slice: ApplicationState & { locale: Locale }
) => {
  const { logInfo } = getLoggers();
  
  if (slice.config.variant === 'unified-mobile') {
    document.getElementById('app')?.setAttribute('class', 'unified-mobile');
  }

  if (slice.config.variant === 'large-buttons') {
    try {
      const shouldEnableCompleteAccount =
        'enableCompleteAccount' in slice.config ? slice.config.enableCompleteAccount : false;
    
      const shouldUseFederated =
        slice.queryState.st_use_federated ||
        shouldEnableCompleteAccount ||
        sessionStorage.getItem('sentry_use_federated') === 'true';
    
      logInfo(`[initialize-application] Should use federated: ${shouldUseFederated}`);
    } catch (error) {
      logInfo(`[initialize-application] Error: ${error}`);
    }
  }

  setSentry(slice);
  getApplicationStore().setState({ loading: false, ...slice });
  getConfigurationsStore().setState({
    locale: slice.locale,
  });
};

export const createPage = pageCreator(document.getElementById('app'), {
  getAnalytics: getAnalyticsState,
  getConfigurationsState,
  getApplicationState,
});
